import { DialogProps, Modal } from '@sandtech-hub-monorepo/ui-kit';
import { ViewerQuery } from '@sandtech-hub-monorepo/ehub-client';
import { DataCollectionModal } from '../../components/data-collection/DataCollectionModal';

interface Props extends Omit<DialogProps, 'onOpenChange'> {
  viewer?: ViewerQuery['viewer'];
  onComplete: () => void;
}

export const DataWallDialog = ({ viewer, onComplete, ...props }: Props) => {
  return (
    <Modal {...props}>
      <DataCollectionModal
        viewer={viewer}
        completionLabel="Continue"
        onComplete={onComplete}
      />
    </Modal>
  );
};
